export const MAIN_TOPIC_MAX_LEVEL = 2;

export enum CreateFormField {
  Topic = 'topic',
  Detail = 'detail',
  Issues = 'issues',
  File = 'file',
  RelatedShop = 'related_shop',
  OrderId = 'order_id',
  Email = 'email',
  Name = 'name',
  region = 'region'
}
